<template>
  <div v-if="isLoaded">
    <div class="brand-details font-manrope">
      <div
        class="d-flex w-100"
      >
        <b-carousel
          v-if="brandDetails.banner.length > 1"
          id="carousel-interval"
          :controls="false"
          :indicators="false"
          fade
          :interval="3000"
          class="banner-carousel"
        >
          <b-carousel-slide
            v-for="img in brandDetails.banner"
            :key="img"
          >
            <template #img>
              <b-img
                class="banner-image"
                :src="`${img}?t=${Date.now()}`"
              />
            </template>
          </b-carousel-slide>
        </b-carousel>
        <b-img
          v-else
          class="banner-image"
          :src="`${(brandDetails.banner && brandDetails.banner[0]) || defaultBanner}?t=${Date.now()}`"
        />
      </div>

      <!-- details card -->
      <div class="detail-card">
        <div
          id="intro_brand_info"
          class="details-container"
        >
          <brand-preview-card :brand-details="brandDetails" />
        </div>
        <brand-collections />
      </div>
    </div>
    <tool-kit :toolkit-page="TOOLKIT_PAGE.BRAND_PROFILE" />
  </div>
</template>

<script>
import { BImg, BCarousel, BCarouselSlide } from 'bootstrap-vue'
import { useBrandDetail } from '@/composables/useBrandDetail'
import analytics from '@/@core/utils/analytics'
import constants, { TOOLKIT_PAGE } from '@/constants'
import ToolKit from '@/@core/components/tool-kit/ToolKit.vue'
import BrandPreviewCard from './BrandPreviewCard.vue'
import BrandCollections from './BrandCollections.vue'
import UserRoleMixin from '../../UserRoleMixin.vue'

export default {
  name: 'BrandDetail',
  components: {
    BImg,
    BrandPreviewCard,
    BrandCollections,
    ToolKit,
    BCarousel,
    BCarouselSlide,
  },
  mixins: [UserRoleMixin],
  setup() {
    const composable = useBrandDetail()
    return {
      ...composable,
    }
  },
  data() {
    return {
      brandId: this.$route.params.brandId,
      defaultBanner: require('@/assets/images/banner/default-banner.jpg'),
      TOOLKIT_PAGE,
    }
  },
  watch: {
    '$route.params.brandId': {
      handler(brandId) {
        if (brandId !== this.brandId) {
          this.brandId = brandId
          this.loadBrand()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.loadBrand()
  },
  methods: {
    loadBrand() {
      this.fetchBrandDetails(this.brandId)
        .then(brand => {
          if (brand) {
            this.$route.meta.breadcrumb = this.$route.meta.breadcrumb.map(
              item => {
                if (item.dynamic === true) {
                  item.brandName = brand.entityName || 'New Brand'
                }
                return item
              },
            )
            if (this.isRetailer) {
              analytics.track(constants.TRACKS.PAGES.RETAILER_OPENS_BRANDS_PROFILE, { entityName: brand.entityName, id: brand._id })
            }
          }
        })
    },
  },
}
</script>
<style lang="scss">
@import '~@core/scss/base/pages/app-brand-preview.scss';

.banner-carousel {
  width: 100%;
  z-index: -1;
}
</style>
